import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-right mb-4" }
const _hoisted_2 = {
  filter: "createdOn",
  filterType: "date",
  sort: "createdOn"
}
const _hoisted_3 = {
  width: "100",
  filter: "name",
  sort: "name"
}
const _hoisted_4 = {
  width: "200",
  filter: "subTitle",
  sort: "subTitle"
}
const _hoisted_5 = {
  filter: "preziario['it'].importo",
  sort: "preziario['it'].importo"
}
const _hoisted_6 = {
  filter: "displayOrder",
  sort: "displayOrder"
}
const _hoisted_7 = {
  filter: "shopCategoryName",
  sort: "shopCategoryName"
}
const _hoisted_8 = {
  filter: "appleIapId",
  sort: "appleIapId"
}
const _hoisted_9 = {
  filter: "upsellIdentifier",
  filterType: "checkbox",
  sort: "upsellIdentifier"
}
const _hoisted_10 = {
  filter: "disabled",
  filterType: "checkbox",
  sort: "disabled"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { colspan: "99" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "btn btn-primary",
        to: "/shopConfig/offer/0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_localized_text, {
            localizedKey: "Nuova offerta",
            text: "Nuova offerta"
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.items,
      filtersFn: _ctx.filtersFn
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data creazione",
                text: "Data creazione"
              })
            ]),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nome",
                text: "Nome"
              })
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Sottotitolo",
                text: "Sottotitolo"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Prezzo IT",
                text: "Prezzo IT"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Ordinamento",
                text: "Ordinamento"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Categoria",
                text: "Categoria"
              })
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Id Apple",
                text: "Id Apple"
              })
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Upsell",
                text: "Upsell"
              })
            ]),
            _createElementVNode("td", _hoisted_10, [
              _createVNode(_component_localized_text, {
                localizedKey: "Visibile",
                text: "Visibile"
              })
            ]),
            _hoisted_11
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                _createElementVNode("td", _hoisted_13, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn)), 1),
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, _toDisplayString(item.subTitle), 1),
              _createElementVNode("td", null, _toDisplayString(item.preziario && item.preziario['it'] && item.preziario['it'].importo), 1),
              _createElementVNode("td", null, _toDisplayString(item.displayOrder), 1),
              _createElementVNode("td", null, _toDisplayString(item.shopCategoryName), 1),
              _createElementVNode("td", null, _toDisplayString(item.appleIapId), 1),
              _createElementVNode("td", null, [
                (!!item.upsellIdentifier)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "SI"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15))
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-sm", { 'btn-success': !item.disabled, 'btn-danger': item.disabled }]),
                  onClick: ($event: any) => (_ctx.disableItem(item))
                }, [
                  (item.disabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "NO"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_18, "SI"))
                ], 10, _hoisted_16)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary ml-2",
                  onClick: ($event: any) => (_ctx.$router.push('/shopConfig/offer/' + item.identifier))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Dettaglio",
                    text: "Dettaglio"
                  })
                ], 8, _hoisted_19),
                (_ctx.$store.state.isAdmin())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-warning ml-2",
                      onClick: ($event: any) => (_ctx.duplica(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Duplica",
                        text: "Duplica"
                      })
                    ], 8, _hoisted_20))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.isAdmin())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-danger ml-2",
                      onClick: ($event: any) => (_ctx.removeItem(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Elimina",
                        text: "Elimina"
                      })
                    ], 8, _hoisted_21))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items", "filtersFn"])
  ]))
}